<section id="photos-videos" class="component component--photos-videos photos-videos bg-color-lightest text-color-dark">
	<div class="wrapper wrapper-800">
		<h2 class="component__title text-center" *ngIf="photosVideosData.pv_heading != ''" [innerHtml]="photosVideosData.pv_heading"></h2>
		<div class="entry-content photos-videos__content" *ngIf="photosVideosData.pv_intro_text != ''" [innerHtml]="photosVideosData.pv_intro_text | safe:'preamble'"></div>
	</div>
	<div class="photos-videos__wrapper" *ngIf="'' != flickreData || '' != youtubeData || '' != vimeoData">
		<div class="wrapper">
			<div class="photos-videos__repeater" *ngIf="'' != flickreData">
				<h3 class="repeater__title" [innerHtml]="flickreData.cst_title">
					<span *ngIf="flickreData.cst_link.url"> | 
						<small>
							<a href="{{ flickreData.cst_link.url }}" target="{{ flickreData.cst_link.target }}">
								<span *ngIf="flickreData.cst_link.title" [innerHtml]="flickreData.cst_link.title"></span>
								<span *ngIf="!flickreData.cst_link.title">see all</span>
							</a>
						</small>
					</span>
				</h3>
				<div class="swiper-container" [swiper]="flickr_config" *ngIf="flickreData.count_data > 0">
					<div class="swiper-wrapper" id="flickrgallery">
						<a class="swiper-slide" *ngFor="let fdVal of flickreData.data"  href="{{ fdVal.link }}">
							<img [defaultImage]="fdVal.url" [lazyLoad]="fdVal.url" class="img-responsive" alt="{{ fdVal.title }}" (click)="loadGallery( 'flickr' )" loading="lazy" />
						</a>
					</div>
					<div class="swiper-button-prev" [hidden]="flickr_config.navigation === false"></div>
					<div class="swiper-button-next" [hidden]="flickr_config.navigation === false"></div>
				</div>
			</div>
			<div class="photos-videos__repeater video-section" *ngIf="'' != youtubeData">
				<h3 class="repeater__title" [innerHtml]="youtubeData?.cst_title">
					<span *ngIf="youtubeData.cst_link.url"> | 
						<small>
							<a href="{{ youtubeData?.cst_link?.url }}" target="{{ youtubeData?.cst_link?.target }}">
								<span *ngIf="youtubeData?.cst_link?.title" [innerHtml]="youtubeData?.cst_link?.title"></span>
								<span *ngIf="!youtubeData?.cst_link?.title">see all</span>
							</a>
						</small>
					</span>
				</h3>
				<div class="swiper-container" [swiper]="youtube_config" *ngIf="youtubeData.count_data > 0">
					<div class="swiper-wrapper" id="youtubegallery">
						<a class="swiper-slide" *ngFor="let ydVal of youtubeData.data"  href="https://www.youtube.com/watch?v={{ ydVal.youtube_id}}">
							<img [defaultImage]="ydVal.img_link" [lazyLoad]="ydVal.img_link" class="img-responsive" alt="{{ ydVal.title }}" (click)="loadGallery( 'youtube' )" loading="lazy" width="273" />
							<i class="icon-placeholder-video"></i>
						</a>
					</div>
					<div class="swiper-button-prev" [hidden]="youtube_config.navigation === false"></div>
					<div class="swiper-button-next" [hidden]="youtube_config.navigation === false"></div>
				</div>
			</div>
			<div class="photos-videos__repeater video-section" *ngIf="'' != vimeoData">
				<h3 class="repeater__title" [innerHtml]="vimeoData?.cst_title">
					<span *ngIf="vimeoData.cst_link.url"> | 
						<small>
							<a href="{{ vimeoData?.cst_link.url }}" target="{{ vimeoData?.cst_link?.target }}">
								<span *ngIf="vimeoData?.cst_link?.title" [innerHtml]="vimeoData?.cst_link?.title"></span>
								<span *ngIf="!vimeoData?.cst_link?.title">see all</span>
							</a>
						</small>
					</span>
				</h3>
				<div class="swiper-container" [swiper]="vimeo_config" *ngIf="vimeoData.count_data > 0">
					<div class="swiper-wrapper" id="vimeogallery">
						<a class="swiper-slide" *ngFor="let vdVal of vimeoData.data"  href="{{ vdVal.link }}">
							<img [defaultImage]="vdVal.img_link_with_button" [lazyLoad]="vdVal.img_link_with_button" class="img-responsive" alt="{{ vdVal.title }}" (click)="loadGallery( 'vimeo' )" loading="lazy" width="273" />
						</a>
					</div>
					<div class="swiper-button-prev" [hidden]="vimeo_config.navigation === false"></div>
					<div class="swiper-button-next" [hidden]="vimeo_config.navigation === false"></div>
				</div>
			</div>
		</div>
	</div>
</section>